module.exports = __webpack_public_path__ + "static/media/bg-sky-desk.60fd30a8.svg";